<template>
    <section class="section-style text-center">
        <div class="container"
             data-aos="fade-right"
             data-aos-offset="100"
             data-aos-once="true"
             data-aos-duration="500">
            <h2 class="bd-title section-title default-letter-spacing text-uppercase font-weight-bold font-md">Affiliated Partners</h2>
            <div class="row justify-content-center">

                <div class="col-6 col-sm-6 col-md-4 col-lg-2">
                    <a href="https://www.ultimatejetvacations.com/hotels/myconian-avaton-resort"><img class="icon mb-2" src="/assets/crealco/casa-de-campo.png" height="130" alt="Logo Casa de Campo"/></a>
                </div>
                <div class="col-6 col-sm-6 col-md-4 col-lg-2">
                    <a href="https://www.ultimatejetvacations.com/hotels/myconian-avaton-resort"><img class="icon mb-2" src="/assets/crealco/conradpmita.png" height="130" alt="Conrad"/></a>
                </div>
                <div class="col-6 col-sm-6 col-md-4 col-lg-2">
                    <a href="https://www.ultimatejetvacations.com/hotels/myconian-avaton-resort"><img class="icon mb-2" src="/assets/crealco/la-casad-de-la-playa.png" height="130" alt="La casa de la playa"/></a>
                </div>
                <div class="col-6 col-sm-6 col-md-4 col-lg-2">
                    <a href="https://www.ultimatejetvacations.com/hotels/myconian-avaton-resort"><img class="icon mb-2" src="/assets/crealco/marriot-s.png" height="130" alt="Marriot"/></a>
                </div>
                <div class="col-6 col-sm-6 col-md-4 col-lg-2">
                    <a href="https://www.ultimatejetvacations.com/hotels/myconian-avaton-resort"><img class="icon mb-2" src="/assets/crealco/nizuc.png" height="130" alt="nizuc"/></a>
                </div>
                <div class="col-6 col-sm-6 col-md-4 col-lg-2">
                    <a href="https://www.ultimatejetvacations.com/hotels/myconian-avaton-resort"><img class="icon mb-2" src="/assets/crealco/waldorf-astoria.png" height="130" alt="Waldorf Astoria"/></a>
                </div>                
            
            </div>
        </div>
    </section>
</template>

<script>

    import AOS from 'aos';
    import 'aos/dist/aos.css';

    AOS.init();

    export default {
        mounted() {

        }
    }

</script>

<style lang="scss" type="text/scss">
    /** Unique Index Styles **/
</style>